import React, { useEffect } from 'react';
import { X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  // Close on escape key
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);
  return <AnimatePresence data-id="element-243">
      {isOpen && <>
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-navy-900/80 backdrop-blur-sm z-50" data-id="element-244" />

          {/* Modal Content */}
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4 pointer-events-none" data-id="element-245">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} className="bg-navy-800 border border-gold-400/20 w-full max-w-lg max-h-[80vh] overflow-y-auto rounded-xl shadow-2xl pointer-events-auto" data-id="element-246">
              <div className="sticky top-0 bg-navy-800/95 backdrop-blur border-b border-white/5 p-4 flex justify-between items-center" data-id="element-247">
                <h3 className="font-serif text-xl text-gold-400" data-id="element-248">{title}</h3>
                <button onClick={onClose} className="text-cream-100/50 hover:text-cream-50 transition-colors p-1" data-id="element-249">
                  <X className="w-5 h-5" data-id="element-250" />
                </button>
              </div>

              <div className="p-6 text-cream-100/80 leading-relaxed space-y-4 text-sm" data-id="element-251">
                {children}
              </div>
            </motion.div>
          </div>
        </>}
    </AnimatePresence>;
}